import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const cols = [
  { title: "Services", links: ["Booth Design", "Brand Activations", "Rentals & Logistics", "Digital & AV"] },
  { title: "Company", links: ["Work", "Process", "About", "Careers"] },
  { title: "Social", links: ["Instagram", "LinkedIn", "Behance"] },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const navigate = useNavigate();
  return (
    <footer className="border-t border-white/10 bg-[#050505]">
      <div className="mx-auto max-w-[1600px] px-6 py-24 md:px-10 md:py-32">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2">
          <div>
            <div className="mb-6 flex items-center gap-3">
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/40">
                Ready when you are
              </span>
            </div>
            <button
              data-testid="footer-quote-btn"
              onClick={() => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" })}
              className="group flex items-center gap-4 text-left"
            >
              <span className="font-display text-[16vw] font-bold uppercase leading-[0.8] tracking-tighter md:text-[9rem]">
                Visions
              </span>
              <ArrowUpRight className="mb-3 h-10 w-10 self-end text-[#FF3B30] transition-transform group-hover:translate-x-1 group-hover:-translate-y-1 md:h-16 md:w-16" />
            </button>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
            {cols.map((c) => (
              <div key={c.title}>
                <div className="mb-5 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
                  {c.title}
                </div>
                <ul className="space-y-3">
                  {c.links.map((l) => (
                    <li key={l}>
                      <a
                        href="#quote"
                        onClick={(e) => {
                          e.preventDefault();
                          document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });
                        }}
                        className="text-sm font-light text-white/60 transition-colors hover:text-white"
                      >
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-24 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center">
          <span className="font-mono text-xs text-white/40">
            © {year} Visions Displays. All rights reserved.
          </span>
          <div className="flex items-center gap-6">
            <span className="font-mono text-xs text-white/40">
              Design · Fabricate · Deploy — Worldwide
            </span>
            <button
              data-testid="footer-login-btn"
              onClick={() => navigate("/login")}
              className="font-mono text-xs uppercase tracking-[0.15em] text-white/40 transition-colors hover:text-white"
            >
              Team Login
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
